var exports = {
  "column": "xf0b3b88a--7d4804--column",
};

module.exports = exports;
